/* eslint-disable import/prefer-default-export */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'
import LogRocket from 'logrocket'
import { useMixpanel } from 'app/mainframe/context/mixpanel'

import { useAuth } from 'app/mainframe/context/auth'

export const Analytics = ({ children }) => {
  if (process.env.NODE_ENV === 'production') {
    const { currentUser } = useAuth()
    const { mixpanel } = useMixpanel()

    const [logRocketInitialized, setLogRocketInitialized] = useState(false)

    useEffect(() => {
      if (currentUser) {
        const userId = currentUser.id.toString()

        // only track events for non curated users
        if (!currentUser.curated) {
          // Mixpanel
          mixpanel.identify(userId)
          mixpanel.people.set({
            $name: currentUser.name,
            $email: currentUser.email,
            $avatar: currentUser.image,
            username: currentUser.username,
            'Sign up date': currentUser.createdAt,
            USER_ID: userId
          })

          // LogRocket
          if (!logRocketInitialized) {
            setLogRocketInitialized(true)
            LogRocket.init('9zropr/mainframe')
          }

          LogRocket.identify(userId, {
            name: currentUser.name,
            email: currentUser.email,
            username: currentUser.username
          })

          LogRocket.getSessionURL(sessionURL => {
            mixpanel.track('LogRocket', { sessionURL })
          })
        }
      }
    }, [currentUser])

    // track page views
    useEffect(() => {
      const properties = { path: window?.location?.pathname, search: null }
      const search = window?.location?.search
      if (search) {
        properties.search = search
      }
      mixpanel.track('Page Viewed', properties)
    }, [window?.location?.pathname])
  }

  return children
}
